<script>
    export let fill = 'red'
</script>

<style>
    svg#event-selector {
        position: absolute;
        top: 236px;
        left: 43px;
        width: 125.19px;
        height: 31.42px;
    }

    .cls-1 {
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 0.3px;
    }
</style>

<svg id="event-selector" viewBox="0 0 117.75 31.81">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} class="cls-1" width="117.75" height="31.81" rx="15.91"/>
        </g>
    </g>
</svg>